import storage from 'good-storage';
import {APP_NAME, APP_VERSION} from "../config";

export class Cache {
  constructor(session = false) {
    this.key = APP_NAME + "_" + APP_VERSION;
    if (session) this.cache = storage.session;
    else this.cache = storage;
  }

  get() {
    return this.cache.get(this.key, null);
  }

  set(data) {
    this.cache.set(this.key, data)
  }

  remove() {
    this.cache.remove(this.key)
  }

}
